import { State } from '@/redux/reducers/rootReducer'
import ReactDOM from 'react-dom'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import styles from './index.module.less'
import { LangEum } from '@/constant'

const zhTW = {
  step1: '點擊右上角的…',
  step2: '選擇在瀏覽器中打開',
}

const msgMap = {
  [LangEum['zh-MO']]: zhTW,
  [LangEum['zh-TW2']]: zhTW,
  [LangEum['zh-TW']]: zhTW,
  en: {
    step1: 'Click on the "…" in the top-right corner',
    step2: 'Open in Browser',
  },
  ja: {
    step1: '右上の「…」をクリック',
    step2: '「ブラウザで開く」をクリック',
  },
  ko: {
    step1: '오른쪽 상단 클릭….',
    step2: '웹 브라우저에서 열기',
  },
  'zh': {
    step1: '点击右上角的…',
    step2: '选择在浏览器中打开',
  },
  'zh-SG': {
    step1: '点击右上角的…',
    step2: '选择在浏览器中打开',
  },
  'zh-MY': {
    step1: '点击右上角的…',
    step2: '选择在浏览器中打开',
  },
}

function GuideBrowser(props: any) {
  // const lang = useSelector((state: State) => state.editor.editConfig.lang)
  // const obj = msgMap[lang]
  const lang = location.pathname.split('/')[3] || 'zh-TW'
  const obj = msgMap[lang]
  const [visible, setVisible] = useState(true)
  useEffect(() => {
    props.onCancel()
  }, [])
  if (!visible) {
    return null
  }
  return (
    <div
      className={styles['guide-browser']}
      onClick={() => {
        props.onCancel()
        setVisible(false)
      }}
    >
      <div className={styles['arrow']}></div>
      <div className={styles['cont']}>
        <ol>
          <li>{obj.step1}</li>
          <li>{obj.step2}</li>
        </ol>
      </div>
    </div>
  )
}

class GuideBrowserManager {
  dom: any
  constructor() {
    const div = document.createElement('div')
    document.body.appendChild(div)
    this.dom = div
  }

  show() {
    const _this = this
    ReactDOM.render(<GuideBrowser onCancel={_this.hidden} />, this.dom)
  }

  hidden() {
    if (this.dom) {
      ReactDOM.unmountComponentAtNode(this.dom)
      document.body.removeChild(this.dom)
    }
  }
}

export default GuideBrowserManager
